import { isEmpty, difference } from 'lodash'
import { type CartContextItem } from 'providers/cart'
import { type CalculatePriceCheckoutQuery } from 'types/graphql-generated'

interface Props {
  cartItems: CartContextItem[]
  discountItems: CalculatePriceCheckoutQuery['calculatePriceCheckout']['discountItems']
  promoCode: string | null
}

/**
 * Check if all cart items are eligible for discount only if promoCode is provided
 */
export const hasCartAllItemsDiscountEligible = ({
  cartItems,
  discountItems,
  promoCode,
}: Props) => {
  if (!promoCode) {
    return true
  }

  const dicountItemsIds = discountItems?.map((item) => item.itemId)
  const cartItemsIds = cartItems?.map((item) => item.productVariant.id)

  return isEmpty(difference(cartItemsIds, dicountItemsIds))
}
